/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorFormField } from './HchbPayorFormField';
import {
    HchbPayorFormFieldFromJSON,
    HchbPayorFormFieldFromJSONTyped,
    HchbPayorFormFieldToJSON,
    HchbPayorFormFieldToJSONTyped,
} from './HchbPayorFormField';

/**
 * 
 * @export
 * @interface HchbPayorFormSection
 */
export interface HchbPayorFormSection {
    /**
     * 
     */
    key: string;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    fields: Array<HchbPayorFormField>;
}

/**
 * Check if a given object implements the HchbPayorFormSection interface.
 */
export function instanceOfHchbPayorFormSection(value: object): value is HchbPayorFormSection {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function HchbPayorFormSectionFromJSON(json: any): HchbPayorFormSection {
    return HchbPayorFormSectionFromJSONTyped(json, false);
}

export function HchbPayorFormSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorFormSection {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'fields': ((json['fields'] as Array<any>).map(HchbPayorFormFieldFromJSON)),
    };
}

export function HchbPayorFormSectionToJSON(json: any): HchbPayorFormSection {
    return HchbPayorFormSectionToJSONTyped(json, false);
}

export function HchbPayorFormSectionToJSONTyped(value?: HchbPayorFormSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'fields': ((value['fields'] as Array<any>).map(HchbPayorFormFieldToJSON)),
    };
}

